import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { useT } from '@/i18n';
import styles from '@/pages/pages.module.css';

import { BridgeMark } from './Icons';

/**
 * The way back to a fresh bridge, the same everywhere: the Bridge mark (it turns a quarter on hover) and
 * the words in blue. On a finished bridge it reads “Create another bridge” (for whoever was sent it,
 * “Create your own bridge”); a status or error screen passes its own words.
 */
export function NewBridgeLink({ own = false, children }: { readonly own?: boolean; readonly children?: ReactNode }): React.JSX.Element {
  const t = useT();
  return (
    <Link to="/" className={styles.another} data-testid="new-bridge">
      <BridgeMark size={13} />
      {children ?? (own ? t('newBridgeLink.own') : t('newBridgeLink.another'))}
    </Link>
  );
}
